// USA
export const locale = {
  lang: "th",
  data: {
    APP_NAME: "Wise",
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    QUIZ: {
      SEARCH_TITLE: "อยากทบทวนเรื่องไหน ลองค้นหาดูเลย",
      SEARCH_PLACEHOLDER: "ค้นหาแบบฝึกหัด หรือชื่อคอร์ส",
      SEARCH_CLEAR: "ล้างคำค้นหา",
      SEARCH_EMPTY: "ไม่พบแบบฝึกหัดที่ค้นหา",
      EMPTY_HINT: "เมื่อลงเรียนคอร์สที่มีแบบฝึกหัด ชุดฝึกจะขึ้นที่หน้านี้",
      MY_DRILLS: "ชุดฝึกของฉัน",
      MY_DRILLS_HINT: "ชุดที่สร้างจากหัวข้อที่ยังอ่อน ทำซ้ำได้เรื่อย ๆ ได้ข้อใหม่ทุกครั้ง",
      CONTINUE_DRILL: "ทำต่อ",
      TITLE: "แบบฝึกหัด",
      RESULT: "ผลแบบฝึกหัด",
      HISTORY: "ประวัติการทำแบบฝึกหัด",
      MY_SKILLS: "ทักษะของฉัน",
      CHILD_SKILLS: "ทักษะของนักเรียน",
      EMPTY: "ยังไม่มีแบบฝึกหัดสำหรับคอร์สที่คุณลงทะเบียนไว้",
      NONE_FOR_COURSE: "คอร์สนี้ยังไม่มีแบบฝึกหัด",
      NO_HISTORY: "ยังไม่เคยทำแบบฝึกหัด",
      NO_HISTORY_HINT: "ทำแบบฝึกหัดสักชุด แล้วผลจะมาแสดงที่นี่ พร้อมเฉลยและคำอธิบายรายข้อ",
      GO_PRACTISE: "ไปทำแบบฝึกหัด",
      NO_SKILL_DATA: "ทำแบบฝึกหัดสักชุดก่อน แล้วเราจะสรุปให้ว่าคุณเก่งเรื่องไหนและควรทบทวนเรื่องไหน",
      QUESTION: "ข้อ",
      QUESTION_COUNT: "จำนวนข้อ",
      PASS_PERCENT: "เกณฑ์ผ่าน",
      START: "เริ่มทำ",
      RETAKE: "ทำอีกครั้ง",
      NO_RETAKE: "ทำได้ครั้งเดียว",
      BEST_RESULT: "ผลที่ดีที่สุด",
      VIEW_RESULT: "ดูผล",
      KIND_PRACTICE: "ชุดฝึกเฉพาะเรื่อง",
      NEXT: "ถัดไป",
      BACK: "ย้อนกลับ",
      TO_REVIEW: "ตรวจทาน",
      REVIEW: "ตรวจทานก่อนส่ง",
      UNANSWERED: "ยังไม่ได้ตอบอีก",
      ITEMS: "ข้อ",
      ALL_ANSWERED: "ตอบครบทุกข้อแล้ว",
      SUBMIT: "ส่งคำตอบ",
      SUBMITTING: "กำลังส่ง…",
      TYPE_ANSWER: "พิมพ์คำตอบ",
      CORRECT: "ตอบถูก",
      PASSED: "ผ่านเกณฑ์",
      NOT_PASSED: "ยังไม่ผ่านเกณฑ์",
      BY_TOPIC: "แยกตามหัวข้อ",
      BY_DIFFICULTY: "แยกตามระดับความยาก",
      ANSWER_KEY: "เฉลยและคำอธิบาย",
      MISCONCEPTION: "ที่ผิดเพราะ",
      REPEATED_MISTAKES: "ข้อผิดที่ซ้ำเดิม",
      REPEATED_MISTAKES_HINT: "ผิดแบบเดียวกันหลายครั้ง แปลว่ายังเข้าใจผิดอยู่ ไม่ใช่เผลอ",
      REVIEW_DUE: "ควรกลับไปทวน",
      REVIEW_DUE_HINT: "เคยทำได้ แต่ไม่ได้ทวนนานแล้ว",
      REVIEW_BADGE: "ควรทบทวน",
      YOUR_ANSWER: "คำตอบของคุณ",
      CORRECT_ANSWER: "เฉลย",
      NO_ANSWER: "ไม่ได้ตอบ",
      EXPLANATION: "คำอธิบาย",
      BACK_TO_LIST: "กลับไปหน้าแบบฝึกหัด",
      SCORE: "คะแนน",
      ANSWERED: "ข้อที่ทำไปแล้ว",
      STRONG_TOPICS: "เรื่องที่แข็ง",
      WEAK_TOPICS: "เรื่องที่ต้องทบทวน",
      IMPROVING: "กำลังดีขึ้น",
      WHAT_NEXT: "ควรทบทวนเรื่องอะไรต่อ",
      SUMMARY: "สรุปให้ฟัง",
      SUMMARY_AUTO: "สรุปอัตโนมัติจากผลการทำแบบฝึกหัด",
      START_HERE: "เริ่มจากตรงนี้",
      NEEDS_FIRST: "ต้องแม่นเรื่องนี้ก่อน:",
      ABILITY: "ระดับความสามารถ",
      ABILITY_HINT: "โอกาสตอบถูกถ้าเจอข้อระดับปานกลาง คิดจากความยากของข้อที่เคยทำ",
      LEVEL: "ระดับ",
      LEVEL_RANGE: "อยู่ระหว่าง",
      LEVEL_HINT: "ระดับเดียวกับระดับข้อสอบ — อยู่ระดับไหน แปลว่ามีโอกาสราวครึ่งหนึ่งที่จะทำข้อระดับนั้นได้",
      BY_LEVEL: "แยกตามระดับข้อ",
      SUGGESTED_COURSES: "คอร์สที่น่าจะช่วยได้",
      ALREADY_ENROLLED: "มีคอร์สนี้แล้ว",
      VIEW_COURSE: "ดูคอร์ส",
      FOR_STUDENT: "รายงานของ",
      REWATCH: "ดูวิดีโอซ้ำ",
      PRACTISE: "ฝึกเรื่องนี้",
      BUILDING: "กำลังสร้าง…",
    },
    FOOTER: {
      BLURB: "แพลตฟอร์มเรียนออนไลน์ที่ไม่ได้จบแค่วิดีโอ — แบบฝึกหัด รายงานทักษะรายคน และคำแนะนำว่าควรทบทวนอะไรต่อ",
      EXPLORE: "เริ่มต้นใช้งาน",
      COMPANY: "เกี่ยวกับ",
      CONTACT: "ติดต่อ",
      DEMO_NOTE: "ระบบสาธิต — ข้อมูล รูปภาพ และการชำระเงินทั้งหมดเป็นตัวอย่าง ไม่ใช่ข้อมูลจริง",
      RIGHTS: "สงวนลิขสิทธิ์",
      LEGAL: {
        PRIVACY: "นโยบายความเป็นส่วนตัว",
        TERMS: "ข้อกำหนดและเงื่อนไข",
        COOKIES: "นโยบายคุกกี้",
        PAYMENT: "นโยบายการชำระเงินและโปรโมชัน",
      },
    },
    LEGAL: {
      UPDATED: "วันที่มีผลบังคับใช้: วันพฤหัสบดี ที่ 1 กันยายน พ.ศ. 2569",
      DEMO_NOTE:
        "ข้อความนโยบายนี้เป็นตัวอย่างสำหรับระบบสาธิตเท่านั้น ไม่ใช่คำแนะนำทางกฎหมาย และไม่มีผลบังคับกับบริการจริง",
      PRIVACY: {
        TITLE: "นโยบายความเป็นส่วนตัว",
        INTRO:
          "นโยบายนี้อธิบายว่า Wise เก็บข้อมูลส่วนบุคคลใดบ้างเมื่อคุณใช้งานระบบสาธิตนี้ เก็บไปเพื่ออะไร และคุณมีสิทธิเลือกอย่างไร เนื่องจากเป็นระบบสาธิต บัญชีและข้อมูลทั้งหมดจึงเป็นข้อมูลตัวอย่างที่สร้างไว้ล่วงหน้า",
        S1: {
          HEAD: "ข้อมูลที่เราเก็บ",
          P1: "เมื่อคุณสร้างบัญชีหรือใช้ปุ่มเข้าสู่ระบบสาธิตแบบคลิกเดียว เราจะเก็บชื่อและอีเมลของบัญชีนั้น พร้อมกับคอร์สและแบบฝึกหัดที่คุณเปิดดู",
          P2: "เราเก็บข้อมูลทางเทคนิคพื้นฐานด้วย เช่น ชนิดของเบราว์เซอร์ อุปกรณ์ และหน้าที่เข้าชม เพื่อให้ระบบสาธิตทำงานได้และปลอดภัย",
        },
        S2: {
          HEAD: "เราใช้ข้อมูลอย่างไร",
          P1: "ข้อมูลถูกใช้เพื่อให้บริการแพลตฟอร์ม ได้แก่ การเข้าสู่ระบบ การแสดงความคืบหน้าและรายงานทักษะ และการจดจำการตั้งค่าของคุณ เช่น ภาษา",
          P2: "เราไม่ขายข้อมูลส่วนบุคคล ในการติดตั้งใช้งานจริง ข้อมูลจะถูกประมวลผลเพื่อให้บริการการเรียนและปฏิบัติตามข้อกำหนดทางกฎหมายและบัญชีเท่านั้น",
        },
        S3: {
          HEAD: "สิทธิของคุณและการติดต่อ",
          P1: "คุณสามารถขอสำเนาข้อมูลของคุณ ขอให้แก้ไข หรือขอให้ลบบัญชีได้ ในระบบสาธิตนี้ บัญชีตัวอย่างจะถูกรีเซ็ตเป็นระยะ",
          P2: "หากต้องการยื่นคำขอเกี่ยวกับความเป็นส่วนตัว โปรดติดต่อผู้ดูแลระบบตามช่องทางในส่วนติดต่อของเว็บไซต์",
        },
      },
      TERMS: {
        TITLE: "ข้อกำหนดและเงื่อนไข",
        INTRO:
          "ข้อกำหนดนี้ใช้บังคับกับการใช้งานแพลตฟอร์ม Wise การสร้างบัญชีหรือการใช้ระบบสาธิตถือว่าคุณยอมรับข้อกำหนดนี้",
        S1: {
          HEAD: "การยอมรับข้อกำหนด",
          P1: "หากคุณไม่ยอมรับข้อกำหนดส่วนใดส่วนหนึ่ง โปรดงดใช้งานแพลตฟอร์ม",
          P2: "เราอาจปรับปรุงข้อกำหนดเมื่อบริการเปลี่ยนแปลง การใช้งานต่อหลังการปรับปรุงถือว่าคุณยอมรับข้อกำหนดฉบับแก้ไข",
        },
        S2: {
          HEAD: "บัญชีผู้ใช้และการใช้งานที่เหมาะสม",
          P1: "คุณต้องรับผิดชอบต่อการใช้งานภายใต้บัญชีของคุณและการรักษารหัสผ่านให้ปลอดภัย บัญชีสาธิตเป็นบัญชีตัวอย่างที่ใช้ร่วมกัน ไม่ควรเก็บข้อมูลส่วนตัว",
          P2: "คุณตกลงจะไม่รบกวนการทำงานของบริการ ไม่พยายามเข้าถึงข้อมูลของผู้ใช้อื่น และไม่คัดลอกเนื้อหาคอร์สเพื่อเผยแพร่ต่อ",
        },
        S3: {
          HEAD: "ทรัพย์สินทางปัญญาและข้อจำกัดความรับผิด",
          P1: "เนื้อหาบทเรียน ข้อความ และส่วนติดต่อผู้ใช้เป็นของ Wise หรือผู้ให้สิทธิ ห้ามทำซ้ำโดยไม่ได้รับอนุญาต",
          P2: "ระบบสาธิตให้บริการ \"ตามสภาพ\" โดยไม่มีการรับประกัน และเท่าที่กฎหมายอนุญาต เราไม่รับผิดต่อความเสียหายใด ๆ ที่เกิดจากการใช้งาน",
        },
      },
      COOKIES: {
        TITLE: "นโยบายคุกกี้",
        INTRO:
          "นโยบายนี้อธิบายคุกกี้และการจัดเก็บข้อมูลในลักษณะเดียวกันที่เว็บไซต์นี้ใช้ และวิธีที่คุณควบคุมได้",
        S1: {
          HEAD: "คุกกี้คืออะไร",
          P1: "คุกกี้คือไฟล์ขนาดเล็กที่เว็บไซต์เก็บไว้ในเบราว์เซอร์ของคุณ เทคโนโลยีที่คล้ายกันได้แก่ local storage ซึ่งเว็บไซต์นี้ใช้เพื่อให้คุณเข้าสู่ระบบค้างไว้และจดจำภาษา",
          P2: "การจัดเก็บบางอย่างจำเป็นต่อการทำงานของเว็บไซต์ ส่วนอื่นเป็นทางเลือก",
        },
        S2: {
          HEAD: "คุกกี้ที่เราใช้",
          P1: "จำเป็น: การจัดเก็บ session และการยืนยันตัวตนที่ทำให้คุณเข้าสู่ระบบค้างไว้และช่วยป้องกันแบบฟอร์ม",
          P2: "การตั้งค่า: ภาษาและการตั้งค่าส่วนติดต่อผู้ใช้ที่คุณเลือก ระบบสาธิตนี้ไม่ใช้คุกกี้โฆษณาหรือวิเคราะห์ของบุคคลที่สาม",
        },
        S3: {
          HEAD: "การจัดการคุกกี้",
          P1: "คุณสามารถล้างหรือบล็อกคุกกี้ได้ในการตั้งค่าเบราว์เซอร์ การบล็อกคุกกี้ที่จำเป็นจะทำให้เข้าสู่ระบบไม่ได้",
          P2: "การล้างข้อมูลที่จัดเก็บจะทำให้คุณออกจากระบบและรีเซ็ตการตั้งค่า เช่น ภาษา",
        },
      },
      PAYMENT: {
        TITLE: "นโยบายการชำระเงินและโปรโมชัน",
        INTRO:
          "นโยบายนี้ครอบคลุมการชำระเงิน ใบเสร็จ การคืนเงิน และโปรโมชัน ในระบบสาธิตนี้ ขั้นตอนชำระเงินเป็นการจำลองทั้งหมด ไม่มีการเรียกเก็บเงินและไม่มีเงินเคลื่อนไหวจริง",
        S1: {
          HEAD: "การชำระเงินและใบเสร็จ",
          P1: "ในการใช้งานจริง ราคาคอร์สจะแสดงเป็นเงินบาทและรวมภาษีที่เกี่ยวข้อง สิทธิเข้าเรียนจะเปิดให้เมื่อยืนยันการชำระเงินแล้ว",
          P2: "ระบบจะออกใบเสร็จหรือใบกำกับภาษีไปยังอีเมลของบัญชีหลังชำระเงินสำเร็จ",
        },
        S2: {
          HEAD: "การคืนเงินและการยกเลิก",
          P1: "คอร์สที่ชำระเงินแล้วขอคืนเงินได้ภายใน 7 วันนับจากวันซื้อ โดยต้องดูบทเรียนไปแล้วไม่เกิน 20%",
          P2: "การคืนเงินจะทำผ่านช่องทางการชำระเงินเดิม เครดิตโปรโมชันและคอร์สฟรีไม่สามารถขอคืนเงินได้",
        },
        S3: {
          HEAD: "โปรโมชันและรหัสส่วนลด",
          P1: "รหัสส่วนลดใช้ได้กับคอร์สที่ร่วมรายการเท่านั้น ใช้ร่วมกันหลายรหัสไม่ได้ และไม่สามารถแลกเป็นเงินสด",
          P2: "เราอาจเปลี่ยนแปลงหรือยุติโปรโมชันเมื่อใดก็ได้ คำสั่งซื้อที่ยืนยันแล้วจะคงราคาเดิมที่ทำรายการไว้",
        },
      },
    },
    MENU: {
      HOME: "หน้าแรก",
      NEW: "new",
      ACTIONS: "Actions",
      CREATE_POST: "Create New Post",
      PAGES: "Pages",
      FEATURES: "Features",
      APPS: "Apps",
      DASHBOARD: "แดชบอร์ด",
      MONITOR: "บันทึกข้อมูลการเรียน",
      PROFILE: "บัญชีและโปรไฟล์",
      PASSWORD: "รหัสผ่าน",
      PARENT_MENU: "เมนูผู้ปกครอง",
      COMPONENT: "Component",
      ABOUT_US: "เกี่ยวกับเรา",
      EXAMS: "คลังข้อสอบ",
      EXAMINATION: "ข้อสอบ",
      EXAMINATION_RESULT: "ผลการทดสอบ",
      COURSES: "คอร์สเรียน",
      COURSE_DETAIL: "รายละเอียดคอร์ส",
      ONLINE_CLASS: "ห้องเรียนออนไลน์",
      PARENT_MONITOR: "การเรียนของลูก",
      PARENT_COURSES: "คลังคอร์ส",
      PARENT_STUDENTS: "จัดการนักเรียน",
      PARENT_COURSE: "คอร์สเรียนที่ซื้อ",
      BLOG: "บทความ",
      MANUAL: "คู่มือการใช้งาน",
      MANUAL_READ: "อ่านคู่มือ",
      MANUAL_VIDEO: "วิดีโอสอนใช้งาน",
    },
    USER_MENU: {
      PROFILE: "โปรไฟล์",
      PURCHASE_ORDER: "ประวัติคำสั่งซื้อ",
      SIGN_IN: "ลงชื่อเข้าใช้",
      SIGN_OUT: "ออกจากระบบ",
      CLASS_ROOM: "ห้องเรียน",
    },
    MONITOR: {
      PROGRESS: "ความคืบหน้า",
      PROGRESS_EMPTY_HINT: "เมื่อลงทะเบียนคอร์สแล้ว ความคืบหน้าของแต่ละคอร์สจะแสดงที่นี่",
    },
    APP: {
      NO_PARENT_LINKED: "ยังไม่มีการเชื่อมต่อกับผู้ปกครอง",
      NO_STUDENT_LINKED: "ยังไม่มีการเชื่อมต่อกับนักเรียน",
      NO_CHILDREN: "ยังไม่มีนักเรียนในความดูแล",
      NO_CHILDREN_HINT: "เพิ่มนักเรียนด้วยรหัสเชิญที่ได้จากบัญชีนักเรียน แล้วจะดูการเรียนและมอบสิทธิ์คอร์สให้ได้",
      NOTHING_TO_PAY: "คอร์สนี้ไม่มีค่าใช้จ่าย เข้าเรียนได้เลย",
      BLOG_EMPTY: "ไม่พบบทความที่ค้นหา",
      BLOG_EMPTY_HINT: "ลองใช้คำอื่น หรือเลือกจากหมวดหมู่ทางซ้าย",
      PARENT_COURSES_EMPTY: "ไม่พบคอร์สในคลัง",
      PARENT_COURSES_EMPTY_HINT: "ลองค้นหาด้วยคำอื่น หรือซื้อคอร์สเพิ่มเพื่อมอบสิทธิ์ให้นักเรียนในความดูแล",
      NEED_BANK: "เลือกธนาคารที่โอนเข้าก่อน จึงจะแจ้งชำระเงินได้",
      NEED_SLIP: "แนบหลักฐานการโอนก่อน จึงจะแจ้งชำระเงินได้",
      PARENT_LIST_HINT: "เชื่อมต่อข้อมูลระหว่างนักเรียนกับผู้ปกครอง",
      STUDENT_LIST: "รายการนักเรียนในความดูแล",
      STUDENT_LIST_HINT: "เพิ่มนักเรียนด้วยรหัสเชิญ เพื่อดูการเรียนและมอบสิทธิ์คอร์สให้",
      COURSE_NOT_FOUND: "ไม่พบคอร์สเรียนนี้",
      COURSE_NOT_FOUND_HINT: "คอร์สนี้อาจถูกปิดหรือลิงก์ไม่ถูกต้อง ลองเลือกจากคอร์สทั้งหมดดูได้",
      BLOG_NOT_FOUND: "ไม่พบบทความนี้",
      BLOG_NOT_FOUND_HINT: "บทความนี้อาจถูกลบหรือลิงก์ไม่ถูกต้อง ลองอ่านบทความอื่นดูได้",
      CATEGORY_EMPTY: "ยังไม่มีคอร์สในหมวดนี้",
      CATEGORY_EMPTY_HINT: "ลองดูหมวดอื่น หรือเปิดดูคอร์สทั้งหมด",
      RECOMMEND_COURSES_EMPTY: "ยังไม่มีคอร์สแนะนำในขณะนี้",
      RECOMMEND_COURSES_EMPTY_HINT: "ลองเปิดดูคอร์สทั้งหมดของเราได้เลย",
      ORDER_NOT_FOUND: "ไม่พบคำสั่งซื้อนี้",
      ORDER_NOT_FOUND_HINT: "คำสั่งซื้อนี้อาจถูกยกเลิกไปแล้ว หรือลิงก์ไม่ถูกต้อง",
      NO_COURSE_YET: "ยังไม่มีคอร์สในห้องเรียน",
      NO_COURSE_YET_HINT: "เลือกคอร์สที่สนใจแล้วเริ่มเรียนได้เลย คอร์สที่ลงทะเบียนแล้วจะมาอยู่ที่นี่",
      SHARE_COURSE: "แชร์คอร์ส",
      COPY_LINK: "คัดลอกลิงก์",
      COPY_LINK_DONE: "คัดลอกลิงก์แล้ว",
      LOAD_ERROR: "โหลดรายการไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
      SEARCH_ORDER: "ค้นหาหมายเลขใบสั่งซื้อ",
      SEARCH_MY_COURSE: "ค้นหาคอร์สของฉัน",
      SEARCH_MY_COURSE_EMPTY: "ไม่พบคอร์สที่ค้นหา",
      PROFILE_MENU: "เมนูบัญชี",
      COPY_INVITE_CODE: "คัดลอกรหัสเชิญ",
      ADD_STUDENT_BY_CODE: "เพิ่มนักเรียนด้วยรหัสเชิญ",
      ADD_STUDENT: "เพิ่มนักเรียน",
      ORDER_COPY_TRACKING: "คัดลอกหมายเลขพัสดุ",
      ORDER_TRACK: "ติดตามพัสดุ",
      APP_NAME: "Wise",
      SOCIAL_MEDIA: "Social Media",
      ACCOUNT_PROFILE: "ข้อมูลส่วนตัว",
      DRAFT: "แบบร่าง",
      WAITING_DOC: "เอกสารรอส่ง",
      IN_PROGRESS: "กำลังดำเนินการ",
      HISTORY: "ประวัติ",
      ATTACHMENTS: "ไฟล์แนบ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      DOCUMENT_NO: "เลขที่เอกสาร",
      TIMELINE: "Timeline",
      ISSUE_NO: "เลขที่หนังสือ",
      SUBJECT: "เรื่อง",
      DEAR: "เรียน",
      NAME_TITLE: "คำนำหน้าชื่อ",
      NAME: "ชื่อ",
      FIRST_NAME: "ชื่อ",
      LAST_NAME: "นามสกุล",
      NICKNAME: "ชื่อเล่น",
      ACADEMY: "สถานศึกษา",
      TYPE: "ประเภท",
      PHONE: "เบอร์โทรศัพท์",
      DOB: "วัน/เดือน/ปี เกิด",
      DATE_FORMAT: "วัน/เดือน/ปี",
      YEAR: "ปี",
      MONTH: "เดือน",
      DAY: "วัน",
      TOPIC: "หัวข้อ",
      FILE_NAME: "ชื่อไฟล์",
      FILE_PLACEHOLDER: "เลือกหรือลากและวางไฟล์ลงที่นี่",
      FILE_PLACEHOLDER_ADD_ON: "รองรับไฟล์นามสกุล PDF",
      FILE_PLACEHOLDER_2: "ลากและวางไฟล์ลงที่นี่หรือ",
      UPLOADED_FILE: "ไฟล์ที่อัปโหลด",
      REMARK: "หมายเหตุ",
      BY: "โดย",
      TEL: "โทร",
      PASS: "ผ่าน",
      FAIL: "ไม่ผ่าน",
      CURRENT_INFORMATION: "ข้อมูลปัจจุบัน",
      FULL_NAME: "ชื่อ-สกุล",
      SEARCH_USER_PLACEHOLDER: "ค้นหาชื่อ, อีเมล",
      SEARCH_PLACEHOLDER_TRACKING: "ค้นหาหมายเลข",
      EMAIL: "อีเมล",
      GENERAL_INFORMATION: "ข้อมูลทั่วไป",
      CONTACT_INFORMATION: "ข้อมูลการดิดต่อ",
      PLACE: "สถานที่",
      START_TIME: "เวลาเริ่มต้น",
      END_TIME: "เวลาสิ้นสุด",
      TOPIC_NAME: "ชื่อหัวข้อ",
      ADD: "เพิ่ม",
      TIME_FORMAT: "ชั่วโมง:นาที",
      HOUR: "ชั่วโมง",
      MINUTE: "นาที",
      SECOND: "วินาที",
      TIME: "เวลา",
      LOCATION: "สถานที่",
      NOTE: "หมายเหตุ",
      REJECT: "ปฏิเสธ",
      WAITING: "รอตอบรับ",
      APPROVE: "อนุมัติ",
      COMMENT: "ความคิดเห็น",
      DETAIL: "รายละเอียด",
      WAITING_FOR_APPROVAL: "รอการอนุมัติ",
      APPROVED: "อนุมัติแล้ว",
      //
      INLINE_SEARCH: "ค้นหา:",
      YES: "ใช่",
      NO: "ไม่ใช่",
      NO_EVENTS: "ไม่มีกิจกรรม",
      NO_ITEMS: "ไม่มีรายการ",
      NO_ITEMS_FOUND: "ไม่มีรายการแสดง",
      NO_FILE_UPLOAD: "ไม่มีไฟล์ที่อัปโหลด",
      NO_COMMENTS: "ไม่มีความคิดเห็น",

      SLOT_TIMES: "ช่วงเวลา",
      PLEASE_COMMENT: "กรุณากรอกคำแนะนำ",
      USER: "รายชื่อผู้ใช้",

      LOADING: "กำลังโหลด",
      PROCESSING: "กำลังประมวลผล",

      // REPORTS
      DATE_PERIOD: "วัน",
      MONTH_PERIOD: "เดือน",
      YEAR_PERIOD: "ปี",
      INLINE_DATE_RANGE: "ช่วงวันที่:",
      INLINE_DATE: "วันที่:",
      INLINE_MONTH: "เดือน:",
      INLINE_YEAR: "ปี:",
      TO: "ถึง",
      START_DATE: "วันที่เริ่มต้น",
      END_DATE: "วันที่สิ้นสุด",
      ITEMS: "รายการ",

      TEACHER: "ผู้สอน",
      WELCOME: "ยินดีต้อนรับ",
      BAHT: "บาท",
      PAY: "ชำระเงิน",
      CANCEL_ORDER: "ยกเลิกรายการ",
      COURSE_DISCOUNT: "ส่วนลดคอร์ส",
      TOTAL_PRICE: "รวมทั้งหมด",
      AMOUNT: "จำนวน",
      COURSE_REVIEWS: "รีวิวจากผู้เรียน",
      ENROLL: "สมัครเรียน",
      ADD_CART: "เพิ่มลงตะกร้า",
      CART_EMPTY: "ยังไม่มีคอร์สในตะกร้า",
      ERROR_404_TITLE: "ไม่พบหน้านี้",
      ERROR_404_BODY: "ลิงก์อาจเปลี่ยนไปแล้ว หรือพิมพ์ที่อยู่ผิดเล็กน้อย ลองกลับไปหน้าแรกหรือดูรายการคอร์สดูครับ",
      ERROR_500_TITLE: "ระบบขัดข้อง",
      ERROR_500_BODY: "มีบางอย่างผิดพลาดฝั่งเรา ลองใหม่อีกครั้งในอีกสักครู่",
      GO_HOME: "กลับหน้าแรก",
      CART_EMPTY_HINT: "เลือกคอร์สที่สนใจแล้วกดเพิ่มลงตะกร้า จะกลับมาชำระเงินทีเดียวก็ได้",
      COURSE_OPTIONS: "สิ่งที่มีในคอร์ส",
      DURATION: "ระยะเวลาเรียน",
      VIDEO_DURATION_EXTRA: "ชั่วโมงส่วนเพิ่ม",
      COURSE_VIDEO: "วิดีโอการสอน",
      EXAMPLE: "แบบฝึกหัด",
      POST_EXAMPLE: "แบบทดสอบหลังเรียน",
      COURSE_DETAIL: "รายละเอียดคอร์ส",

      BROWSE_IMAGE: "เลือกรูป",
      RESET_PASSWORD: "รีเซ็ตรหัสผ่าน",
      CHANGE_PASSWORD: "เปลี่ยนรหัสผ่าน",
      OLD_PASSWORD: "รหัสผ่านเก่า",
      PASSWORD_CONFIRMATION: "ยืนยันรหัสผ่าน",
      NEW_PASSWORD: "รหัสผ่านใหม่",
      NEW_PASSWORD_CONFIRMATION: "ยืนยันรหัสผ่านใหม่",
      NEW_PASSWORD_REQUIRED: "กรุณาตั้งรหัสผ่านใหม่เพื่อดำเนินการ",

      COURSES: "คอร์สเรียน",
      STUDENT: "นักเรียน",
      BUY_NOW: "ดูรายละเอียด",
      STUDENT_REVIEWS: "รีวิวจากน้องๆ",

      SHOW_ALL: "ดูทั้งหมด",
      ALL: "ทั้งหมด",
      NO_DURATION: "ไม่มี",
      NO_EXPIRATION: "ไม่มีกำหนด",

      DISCOUNT: "ส่วนลด",
      DISCOUNT_LABEL: "กรอกโค้ดส่วนลด",
      DISCOUNT_SHORT_LABEL: "ส่วนลด",
      DISCOUNT_PLACEHOLDER: "ส่วนลด (ใส่โค้ดส่วนลด)",
      USE_CODE: "ใช้โค้ด",

      TEACH_BY: "สอนโดย",
      COURSE_DESC: "รายละเอียดบทเรียน",
      COURSE_BENEFITS: "คุณจะได้เรียนอะไรบ้าง",
      VIDEOS: "วิดีโอ",
      LESSON: "บทเรียน",
      NO_LESSON: "ไม่มีบทเรียน",
      FREE: "เรียนฟรี",
      TRIAL_STARTED: "เริ่มทดลองเรียนแล้ว",
      TRIAL_STARTING: "กำลังเริ่ม…",
      TRIAL_ONLY: "เฉพาะคอร์สที่ทดลองเรียนได้",
      TRIAL_BADGE: "ทดลองเรียนได้",
      TRIAL_STUDENT_ONLY: "ทดลองเรียนสำหรับนักเรียนเท่านั้น",
      FREE_TRIAL: "ทดลองเรียน",

      DESCRIPTION: "คำอธิบาย",

      SEND_EMAIL_DESC:
        "ระบบได้ส่งอีเมลไปยังที่อยู่อีเมลของท่านเรียบร้อยแล้ว กรุณาตรวจสอบอีเมลที่ท่านได้รับ",

      //Examination
      BACK: "ย้อนกลับ",
      NEXT: "ไปต่อ",

      SCORE: "คะแนน",
      SCORE_RESULT: "คะแนนที่ทำได้",
      EXAM_ITEM: "ข้อ",
      EXAM_ITEM_PER: "ข้อละ",
      CORRECT_ITEM: "จำนวนข้อที่ทำได้",
      CORRECT_ANS: "ตอบถูก",
      WRONG_ANS: "ตอบผิด",
      SKIP_ANS: "ไม่ตอบ / ข้าม",

      CORRECT_RESULT: "การตอบคำถาม",
      WRONG_RESULT: "ตอบถูกต้อง",
      SKIP_RESULT: "ไม่ตอบเลย",
      NOT_FOUND_RESULT: "ไม่มีผลการทดสอบของบทเรียน",

      FASTEST_ACCURACY: "เร็วที่สุด",
      SLOWEST_ACCURACY: "ช้าที่สุด",
      TOTAL_ACCURACY: "ทั้งหมด",

      CORRECT_ACCURACY: "ความถูกต้อง / ความแม่นยำ",
      SPEED_TIMER: "ความเร็ว / เวลาในการตอบต่อข้อ",

      CONCERN: "คำแนะนำ",
      NO_CONCERN: "ไม่มีคำแนะนำ",

      ADD_CART_SUCCESS: "เพิ่มใส่ตะกร้าเรียบร้อย",
      DISCOUNT_CODE: "รหัสส่วนลด",

      //Parent Course
      SEARCH_COURSE: "ค้นหาคอร์สเรียน",
      PARENT_COURSE: "รายการคอร์สเรียนที่ผู้ปกครองได้ซื้อไว้",
      WAIT_ACTIVE: "รอเปิดใช้งาน",
      INACTIVE: "ยังไม่ใช้งาน",
      NO_COURSE_ACTIVE: "รายการคอร์สยังไม่เปิดใช้งาน",
      GIVE_COURSE: "ให้คอร์ส",
      RECEIVED_STUDENT: "นักเรียนที่ได้รับ",

      COURSE_MANAGE: "จัดการคอร์สให้กับนักเรียน",
      AVAILABLE_COURSE: "จำนวนคอร์สที่เหลือ",

      ALREADY_HAVE_COURSE: "นักเรียนมีคอร์สนี้แล้ว",
      CANCEL_GIVE_COURSE: "ยกเลิกการให้คอร์สเรียบร้อย",
      GIVE_COURSE_SUCCESS: "ให้คอร์สเรียบร้อย",
      GIVE_COURSE_FAILED: "มอบสิทธิ์คอร์สไม่สำเร็จ ลองใหม่อีกครั้ง",

      //Parent Menu
      PARENT_LIST: "รายการผู้ปกครอง",
      PARENT_CONNECTION: "เชื่อมต่อข้อมูลระหว่างนักเรียนกับผู้ปกครอง",
      PARENT_INVITATION: "ลิงค์คำเชิญผู้ปกครอง",
      FILL_INVITATION: "กรอกลิงค์คำเชิญนักเรียน",
      CONTACT: "ติดต่อ",
      PERSON: "คน",
      CARETAKER: "ผู้ดูแล",
      TAKING_CARE: "กำลังดูแล",

      COPY_TRACKING_NO: "คัดลอก Tracking No. เรียบร้อย",
      COPY_INVITED: "คัดลอกลิงค์คำเชิญผู้ปกครองเรียบร้อย",
      ADD_STUDENT_SUCCESS: "เพิ่มนักเรียนสำเร็จ",
      ADD_STUDENT_FAILED: "เพิ่มนักเรียนไม่สำเร็จ",
      INVALID_CODE: "ลิงค์คำเชิญไม่ถูกต้อง",
      DISCONNECTED: "ยกเลิกเชื่อมต่อสำเร็จ",

      //User Password
      PASSWORD_MANAGEMENT: "จัดการรหัสผ่าน",
      CHANGE_RESET_PASSWORD: "แก้ไขและรีเซ็ทรหัสผ่าน",
      SAVE_CHANGE: "บันทึกการเปลี่ยนแปลง",
      RESET_NEW_PASSWORD: "รีเซ็ตรหัสผ่านใหม่",
      SEND_REQ_PASSWORD: "ส่งคำขอรีเซ็ทรหัสผ่าน",
      PASSWORD_REQ_DESC1:
        "อีเมลสำหรับรีเซ็ตรหัสผ่านใหม่จะถูกส่งไปยังอีเมลปัจจุบันของคุณ",
      PASSWORD_REQ_DESC2: "กรุณาตรวจสอบความถูกต้องของอีเมลก่อนดำเนินการ",

      //Purchase Order
      MY_ORDER: "คำสั่งซื้อของฉัน",
      ORDER_DATE: "วันที่สั่งซื้อ",
      ORDER_ITEM: "รายการคอร์สที่ซื้อ",

      TRANSACTION_SUMMARY: "สรุปยอด",
      SUB_TOTAL: "ราคารวม",
      PAY_BY: "ชำระผ่าน",
      CHOOSE_BANK: "เลือกธนาคารที่โอนเข้า",
      BANK_TRANSFER: "โอนชำระผ่านธนาคาร",
      APPROVE_PROCESS: "กำลังตรวจสอบหลักฐาน",
      ACCOUNT_NAME: "ชื่อบัญชี",
      ACCOUNT_NO: "เลขที่บัญชี",
      ATTACH_SLIP: "แนบรูปหลักฐานชำระเงิน",
      SUBMIT_PAYMENT: "ยืนยันชำระเงิน",
      CANCEL_PAYMENT: "ยกเลิกคำสั่งซื้อ",
      ORDER_APPROVED: "ตรวจสอบเรียบร้อย",
      ORDER_CANCELED: "ยกเลิกแล้ว",
      SUBMIT_PAYMENT_DONE: "ยืนยันการชำระสำเร็จ!",
      CANCEL_PAYMENT_DONE: "ยกเลิกคำสั่งซื้อสำเร็จ!",

      DETAILS: "เนื้อหา",
      CATEGORIES: "หมวดหมู่",
      SEARCH: "ค้นหา",
      BLOG: "บทความ",
      SEARCH_BLOG: "ค้นหาบทความ",
      TOTAL_BLOG: "บทความทั้งหมด",
      PUBLIC: "เผยแพร่",
      RECENT_BLOG: "บทความล่าสุด",

      PDF_FILE: "เอกสาร",
      // PDF_FILE: "เอกสาร PDF",
      FILE_AMOUNT: "ไฟล์",
    },

    LANDING_PAGE: {
      ONLINE_COURSE: "คอร์สเรียนออนไลน์",
      ADVICE_BUTTON: "ดูคอร์สทั้งหมด",
      BANNER_VISION: {
        LINE_1: "เรียนออนไลน์",
        LINE_2: "เห็นผลรายคน",
        LINE_3: "ไม่ใช่แค่ดูวิดีโอ",
        LINE_4: "วิดีโอบทเรียน แบบฝึกหัด และรายงานทักษะรายบุคคล",
        LINE_5: "ครูเห็นว่าเด็กแต่ละคนอ่อนเรื่องไหน และควรทบทวนอะไรต่อ",
        LINE_6: "ระบบสาธิต — กดใช้งานได้ทุกส่วน",
      },
      // The original Edvance banner's own copy — kept as its own namespace
      // rather than sharing BANNER_VISION above, which was rewritten for the
      // Wise rebrand and no longer means the same thing.
      EDVANCE_BANNER: {
        LINE_1: "ภาษาอังกฤษ",
        LINE_2: "ง่ายกว่าที่คิด",
        LINE_3: "ถ้าเรียนแบบถูกวิธี",
        LINE_4: "ฉีกกรอบการเรียนภาษาอังกฤษแบบเดิมๆ",
        LINE_5: "เรียนสนุก เป็นระบบ จบแล้วเชื่อมโยงเป็น",
        LINE_6: "ใช้งานได้จริง!",
        CTA: "สอบถามคอร์สเรียน-ขอทดลองเรียน",
      },
      MARKS: {
        VIDEO: "วิดีโอบทเรียน",
        QUIZ: "แบบฝึกหัดตรวจอัตโนมัติ",
        REPORT: "รายงานทักษะรายคน",
      },
      CTA: {
        EYEBROW: "ลองด้วยตัวเอง",
        HEAD_1: "ลองใช้ดูได้เลย แล้วจะเห็นว่า",
        HEAD_2: "การดูแลรายคน",
        HEAD_3: "ทำได้จริง",
        BODY_1:
          "ระบบนี้ไม่ได้หยุดที่การปล่อยวิดีโอ แต่เก็บผลการทำแบบฝึกหัดของนักเรียนแต่ละคน แล้วสรุปให้ครูเห็นว่าใครอ่อนเรื่องไหน",
        BODY_2:
          "นักเรียนเองก็เห็นว่าควรทบทวนอะไรต่อ ทั้งหมดนี้กดลองได้เลยในระบบสาธิตนี้ — ครูไม่ต้องเดาอีกต่อไป",
      },
      COURSE_CATEGORY: "หมวดหมู่คอร์สเรียน",
      COURSE_CATEGORY_DESC:
        "ถ้ายังไม่สามารถตัดสินใจได้ว่าจะเลือกคอร์สเรียนออนไลน์ไหน เรามีตัวเลือกหมวดหมู่คอร์สเรียนที่เหมาะกับคุณ",
      MORE_COURSE: "ดูคอร์สทั้งหมด",
      SEE_COURSES: "ดูคอร์สในหมวดนี้",
      WHY_WISE: "ระบบนี้ช่วยอะไรได้บ้าง",

      OUR_COURSE: "คอร์สเรียนของเรา",
    },
    ABOUT_US: {
      // Demo copy. The customer build described one English school, its
      // teaching method and its named teacher — none of which belongs on a
      // product demo. This describes the platform instead.
      ABOUT: {
        PARAGRAPH_1:
          "Wise เป็นแพลตฟอร์มเรียนออนไลน์สำหรับสถาบันและติวเตอร์\nที่อยากดูแลผู้เรียนได้เป็นรายคน ไม่ใช่แค่ปล่อยวิดีโอทิ้งไว้\nระบบเก็บทั้งการดูวิดีโอและผลการทำแบบฝึกหัด\nแล้วสรุปให้เห็นว่าผู้เรียนแต่ละคนเข้าใจเรื่องไหนแล้ว\nและยังต้องทบทวนเรื่องอะไร",
        PARAGRAPH_2:
          "หน้านี้เป็นระบบสาธิต\nคุณกดใช้งานได้ทุกส่วนโดยไม่มีผลกับข้อมูลจริง",
        LINE_1: "Wise เป็นแพลตฟอร์มเรียนออนไลน์สำหรับสถาบันและติวเตอร์",
        LINE_2: "ที่อยากดูแลผู้เรียนได้เป็นรายคน ไม่ใช่แค่ปล่อยวิดีโอทิ้งไว้",
        LINE_3: "ระบบเก็บทั้งการดูวิดีโอและผลการทำแบบฝึกหัด",
        LINE_4: "แล้วสรุปให้เห็นว่าผู้เรียนแต่ละคนเข้าใจเรื่องไหนแล้ว",
        LINE_5: "และยังต้องทบทวนเรื่องอะไร",
        LINE_6: "ครูจึงเห็นภาพรายคน ไม่ใช่แค่คะแนนรวมของห้อง",
        LINE_7: "หน้านี้เป็นระบบสาธิต",
        LINE_8: "คุณกดใช้งานได้ทุกส่วนโดยไม่มีผลกับข้อมูลจริง",
      },
      TEACHER: {
        TITLE: "ผู้สอนในระบบสาธิต",
        TITLE_DEFAULT: "ผู้สอน",
        FULLNAME: "ทีมผู้สอนตัวอย่าง",
        NICKNAME: "ระบบสาธิต",
      },
    },
    PURCHASE_ORDER: {
      TITLE: "คำสั่งซื้อของฉัน",
      ORDER_DETAILS: "รายละเอียดคำสั่งซื้อ",
    },
    COURSES: {
      RECOMMEND_COURSE: "คอร์สแนะนำ",
      ALL_COURSE: "คอร์สเรียนทั้งหมด",
      ORDER_DETAILS: "รายละเอียดคำสั่งซื้อ",
    },
    ONLINE_CLASS: {
      LASTED_CLASS: "เข้าเรียนล่าสุด",
      LASTED: "ล่าสุดเมื่อ",
      CHAPTER: "หัวข้อ",
      DURATION_TIME: "เวลาทั้งหมด",
      SPENT_TIME: "เวลาที่ใช้ไป",
      USABLE_TIME: "เวลาคงเหลือ",
      STUDY_TIME: "เวลาเรียน",
      EXPIRE_DATE: "วันหมดอายุ",
      ENTER_CLASS: "เข้าสู่คอร์สเรียน",
      MY_COURSE: "คอร์สเรียนของฉัน",
      TRIAL_LOCKED: "วิดีโอนี้ล็อกอยู่สำหรับการทดลองเรียน ซื้อคอร์สเพื่อดูทั้งหมด",
      NOT_ENROLLED: "คุณยังไม่ได้ลงทะเบียนคอร์สนี้",
      NO_ITEM: "ไม่พบรายการ",

      ACTIVATE_COURSE: "เปิดใช้งาน",
      PROGRESS: "ความคืบหน้า",
      NO_EXPIRE: "ไม่จำกัด",
      PAUSE_CLASS: "พักการเรียนชั่วคราว",

      ABOUT_COURSE: "เกี่ยวกับบทเรียน",
      PDF_FILE: "  ไฟล์เอกสาร PDF",

      EXERCISE: "แบบฝึกหัด",
      EXAMINATION: "ข้อสอบ / แบบทดสอบ",
      NO_DOC: "ไม่มีเอกสาร",

      START: "เริ่มทำ",
      REPEAT: "ทำอีกครั้ง",
      ANALYSIS: "วิเคราะห์",
      NO_EXAM: "ไม่มีบททดสอบ",

      COMMENT_TITLE: "ให้คะแนนและความคิดเห็นของคุณเกี่ยวกับคอร์สนี้",
      COMMENT_PLACEHOLDER: "ระบุความคิดเห็นของคุณที่นี่...",
      COMMENT_SUBMIT: "ส่งความคิดเห็น",
      COMMENT_RATING: "ให้คะแนน",
      COMMENT_SUCCESS: "รีวิวเรียบร้อย",

      COURSE_TIMEOUT: "เวลาเรียนของท่านหมดลงแล้ว",
      ACTIVE_CONFIRM: "ยืนยันการเปิดคอร์สเรียน",
      ACTIVE_CONFIRM_DESC: "คุณต้องการเปิดคอร์สเรียนนี้ใช่หรือไม่?",

      STOP_EXAM: "ยกเลิกทำข้อสอบ",
      ANSWER_DESC: "เฉลย และอธิบายคำตอบ",
      ANSWER_PLACEHOLDER: "กรอกคำตอบของคุณที่ช่องนี้...",
      ANSWER_SUBMIT: "ส่งคำตอบ",

      ANS_EQUAL: "คำตอบ คือ",
      SOLUTION_NO: "วิธีแก้ปัญหาที่",
      RESOLVE_BY: "เฉลยโดย",

      RESULT: "ผลการทดสอบ",
      ENTER_SOLUTION: "ดูเฉลย",
      OVERALL: "ภาพรวม",

      TIMEUP_DIALOG_TITLE: "หมดเวลาการทำข้อสอบ !",
      TIMEUP_DESC_1: "หมดเวลาการทำข้อสอบของชุดข้อสอบนี้แล้ว",
      TIMEUP_DESC_2: 'กรุณากด "ยืนยัน" เพื่อทำการส่งคำตอบ',
    },
    BLOG: {
      FILTER: {
        CATEGORY: "หมวดหมู่",
        SEARCH: "ค้นหา",
        SEARCH_PLACEHOLDER: "ค้นหา...",
      },
    },
    AUTH: {
      OR: "หรือ",
      WELCOME_TEXT: "ยินดีต้อนรับสู่",
      UNAUTHORIZED_ALERT: "กรุณาลงชื่อเข้าใช้ก่อนใช้งาน",
      USERNAME: "ชื่อผู้ใช้งาน",
      EMAIL: "อีเมล",
      PASSWORD: "รหัสผ่าน",
      FORGOT_PASSWORD: "ลืมรหัสผ่าน?",
      ASIDE: {
        SIGN_IN_TITLE: "ยินดีต้อนรับสู่",
        SIGN_IN_BODY: "ลงชื่อเข้าใช้เพื่อกลับไปยังห้องเรียน แบบฝึกหัด และรายงานทักษะของคุณ",
        SIGN_UP_TITLE: "สมัครบัญชีใช้งาน",
        SIGN_UP_BODY: "สมัครเพื่อเก็บความคืบหน้า ทำแบบฝึกหัดได้ไม่จำกัด และดูว่าตัวเองเก่งเรื่องไหน",
        FORGOT_TITLE: "ลืมรหัสผ่าน",
        FORGOT_BODY: "กรอกอีเมลที่ใช้สมัคร แล้วเราจะส่งลิงก์สำหรับตั้งรหัสใหม่ไปให้",
      },
      DEMO_HINT: "นี่คือระบบสาธิต เข้าดูได้เลยด้วยบัญชีตัวอย่าง ไม่ต้องสมัคร",
      DEMO_AS_STUDENT: "เข้าใช้งานเป็นนักเรียน",
      DEMO_AS_PARENT: "เข้าใช้งานเป็นผู้ปกครอง",
      SECTION_ACCOUNT: "บัญชีเข้าใช้งาน",
      SECTION_PROFILE: "ข้อมูลส่วนตัว",
      SECTION_ADDRESS: "ที่อยู่",
      PRIVACY_CONSENT_PREFIX: "ฉันได้อ่านและยอมรับ",
      PRIVACY_CONSENT_REQUIRED: "กรุณายอมรับนโยบายความเป็นส่วนตัวก่อนสมัครสมาชิก",
      POLICY: "เมื่อกดสมัคร ถือว่ายอมรับข้อกำหนดการใช้งานของระบบสาธิตนี้",
      NOT_REGISTER: "ยังไม่มีบัญชีเข้าใช้?",
      ALREADY_REGISTER: "มีบัญชีเข้าใช้แล้ว?",
      SIGN_IN: "เข้าสู่ระบบ",
      SIGN_UP: "ลงทะเบียน",
      SUBMIT_SIGN_UP: "ยืนยันลงทะเบียน",
      SIGN_OUT: "ออกจากระบบ",
      SIGN_INING: "กำลังเข้าสู่ระบบ",
      REGISTERING: "กำลังลงทะเบียน",
      REGISTER_ERROR: "ข้อมูลลงทะเบียนไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง",
      EMAIL_TAKEN: "อีเมลนี้ถูกใช้สมัครแล้ว ลองเข้าสู่ระบบหรือใช้อีเมลอื่น",
      NAME_TAKEN: "ชื่อ-นามสกุลนี้ถูกใช้งานแล้ว",
      INVALID_LOGIN:
        "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง",
      INVALID_VERIFY:
        "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง หรือไม่มีสิทธิ์ในการใช้งาน โปรดตรวจสอบและลองอีกครั้ง",
      WAIT_APPROVE:
        "บัญชีนี้รอการอนุมัติจากผู้ดูแลระบบ กรุณาติดต่อเจ้าหน้าที่หากรอนานเกินไป",
      ACCOUNT_REJECTED:
        "บัญชีนี้ถูกปฏิเสธการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      GENERAL: {
        OR: "Or",
        SUBMIT_BUTTON: "Submit",
        NO_ACCOUNT: "Don't have an account?",
        SIGNUP_BUTTON: "Sign Up",
        FORGOT_BUTTON: "Forgot Password",
        BACK_BUTTON: "Back",
        PRIVACY: "Privacy",
        LEGAL: "Legal",
        CONTACT: "Contact",
      },
      LOGIN: {
        TITLE: "Login Account",
        BUTTON: "Sign In",
      },
      FORGOT: {
        TITLE: "Forgotten Password?",
        DESC: "Enter your email to reset your password",
        SUCCESS: "Your account has been successfully reset.",
      },
      REGISTER: {
        TITLE: "ลงทะเบียน",
        DESC: "Enter your details to create your account",
        SUCCESS: "Your account has been successfuly registered.",
        NOT_REGISTER: "ยังไม่มีบัญชีใช่หรือไม่?",
      },
      INPUT: {
        EMAIL: "Email",
        FULLNAME: "Fullname",
        PASSWORD: "รหัสผ่าน",
        CONFIRM_PASSWORD: "ยืนยันรหัสผ่าน",
        USERNAME: "Username",
      },
      VALIDATION: {
        INVALID: "{{name}} is not valid",
        REQUIRED: "{{name}} is required",
        MIN_LENGTH: "{{name}} minimum length is {{min}}",
        AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
        NOT_FOUND: "The requested {{name}} is not found",

        INVALID_LOGIN:
          "ชื่อผู้ใช้หรือรหัสผ่านที่คุณป้อนไม่ถูกต้อง โปรดตรวจสอบและลองอีกครั้ง",
        REQUIRED_FIELD: "Required field",
        MIN_LENGTH_FIELD: "Minimum field length:",
        MAX_LENGTH_FIELD: "Maximum field length:",
        INVALID_FIELD: "Field is not valid",
      },
    },

    COMPONENT: {
      ADD: "เพิ่ม",
      CREATE: "สร้าง",
      EDIT: "แก้ไข",
      DELETE: "ลบออก",
      VIEW_DATA: "ดูข้อมูล",
      DOWNLOAD: "ดาวน์โหลด",
      UPLOAD: "อัปโหลด",
      BROWSE_FILE: "เลือกไฟล์",
      PRINT: "พิมพ์",
      SAVE: "บันทึก",
      SAVE_DRAFT: "บันทึกแบบร่าง",
      VIEW_DETAIL: "ดูรายละเอียด",
      SAVE_CHANGES: "บันทึกการเปลี่ยนแปลง",
      NEW_EVENT: "สร้างกิจกรรมใหม่",
      CONFIRM: "ยืนยัน",
      ACCEPT: "ตอบรับ",
      REJECT: "ปฏิเสธ",
      DISAPPROVE: "ไม่อนุมัติ",
      APPROVE: "อนุมัติ",
      APPROVED: "ผ่านการตรวจสอบ",
      CONFIRM_REJECT: "ยืนยืนปฏิเสธ",
      CONFIRM_DISAPPROVE: "ยืนยันส่งแก้ไข",
      SUBMIT: "ส่ง",
      VIEW_COMMENT: "ดูความคิดเห็น",
      APPROPRIATE: "เหมาะสม",
      MUST_REVISE: "ต้องแก้ไข",
      SEND_EMAIL: "ส่งอีเมล",
      ISSUE_A_CERTIFICATE: "ออกใบรับรอง",
      CANCEL: "ยกเลิก",
      CLOSE: "ปิด",
      NEXT: "ถัดไป",
      IMPORT_DATA: "นำเข้าข้อมูล",
      FILE_FORMAT: "รูปแบบไฟล์",
    },
    VALIDATOR: {
      REQUIRED: "กรุณากรอกข้อมูล",
      REQUIRED_DATE: "กรุณากรอกข้อมูลตั้งแต่ 1 วันขึ้นไป",
      MUST_BE_AT_LEAST_X_CHARACTERS: "จำนวนตัวอักษรอย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_LOWER_CASE:
        "ตัวพิมพ์เล็ก [a-z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_LETTER_IN_UPPER_CASE:
        "ตัวพิมพ์ใหญ่ [A-Z] อย่างน้อย {{value}} ตัว",
      MUST_CONTAIN_AT_LEAST_X_NUMBER: "ตัวเลข [0-9] อย่างน้อย {{value}} ตัว",
      INVALID_EMAIL: "กรุณากรอกอีเมลที่ถูกต้อง",
      PASSWORD_MISMATCH: "รหัสผ่านไม่ตรงกัน",
      PASSWORD_INVALID: "รูปแบบ 'รหัสผ่าน' ไม่ถูกต้อง",
      PLEASE_SELECT: "กรุณาเลือก",
      PLEASE_SELECT_TIME_SLOTS: "กรุณาเลือกช่วงเวลา",
      PLEASE_SELECT_FILE: "กรุณาเลือกไฟล์",
      PLEASE_ADD_ALL_DOCUMENTS: "กรุณาเพิ่มเอกสารให้ครบทุกหัวข้อ",
      DUPLICATE_DOC_NO: "เลขที่เอกสารมีในระบบแล้วกรุณากรอกใหม่",
      MUST_MATCH: "รหัสผ่านใหม่และยืนยันรหัสผ่านใหม่ต้องเหมือนกัน",

      ERROR: "ผิดพลาด",
      SOMETHING_ERROR: "เกิดข้อผิดพลาด",
      CHANGE_PASSWORD_SUCCESS: "เปลี่ยนรหัสผ่านสำเร็จ",
      CHANGE_PASSWORD_DUPLICATED:
        "ไม่สามารถใช้รหัสผ่านใหม่ที่เหมือนกับรหัสผ่านเก่า",
      CHANGE_PASSWORD_INVALID: "รหัสผ่านเก่าไม่ถูกต้อง",
      CHANGE_PASSWORD_ERROR: "มีข้อผิดพลาดกรุณาตรวจสอบ",
    },
    SWEETALERT: {
      CONFIRMATION_TITLE: "การยืนยัน",
      CONFIRMATION_TEXT: "คุณแน่ใจหรือว่าต้องการดำเนินการต่อ?",
      CONFIRMATION_DELETE_TEXT: "คุณแน่ใจหรือว่าต้องการลบสิ้งนี้?",
      CONFIRMATION_SAVE_TITLE: "ยืนยันบันทึก",
      CREATE_DATA: "สร้างข้อมูล",
      CREATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการสร้างข้อมูลนี้?",
      UPDATE_DATA: "อัปเดตข้อมูล",
      UPDATE_DATA_TEXT: "คุณแน่ใจหรือว่าต้องการอัปเดตข้อมูลนี้?",
      SUCCESS_TITLE: "สำเร็จ",
      SUCCESS_TEXT: "สร้างข้อมูลใหม่เรียบร้อยแล้ว",
      SUCCESS_TEXT_UPDATE: "ข้อมูลได้อัปเดตเรียบร้อยแล้วแล้ว",
      SUCCESS_TEXT_DELETE: "ข้อมูลได้ถูกลบเรียบร้อยแล้ว",
      ERROR_TITLE: "ไม่สำเร็จ",
      ERROR_TEXT: "ดูเหมือนว่ามีบางอย่างผิดพลาด",
      WARNING_TITLE: "คำเตือน",
      WARNING_TEXT: "มีบางอย่างไม่ถูกต้อง อาจทำให้คุณไม่สามารถดำเนินการต่อได้",
      WARNING_IMAGE_SIZE_TITLE: "รูปภาพมีขนาดใหญ่เกินไป",
      WARNING_IMAGE_SIZE_TEXT:
        "กรุณาตรวจสอบขนาดรูปภาพต้องไม่เกิน {{value}} {{unit}}.",

      ERROR_APPROVER_DUPLICATE_OWNER: "ผู้ขอไม่สามารถเป็นผู้รับรองได้",
      ERROR_COMMITTEE_DUPLICATE: "ท่านได้เลือกกรรมการท่านนี้แล้ว",
      ERROR_COMMITTEE_EXTERNAL: "กรรมการภายนอกมีได้ไม่เกิน 1 คน",
      ERROR_COMMITTEE_INTERNAL: "กรรมการภายในมีได้ไม่เกิน 2 คน",

      ERROR_NOTFOUND_DOC: "ไม่พบหมายเลขเอกสาร",
      ERROR_NOTFOUND_DOC_BY_NAME: "ไม่พบชื่อ-สกุลที่ค้นหา",
      ERROR_REQUIRED: "กรุณากรอกข้อมูลให้ครบ",
      PROCESSING_TITLE: "ระบบกำลังทำรายการ",
      PROCESSING_TEXT: "กรุณารอสักครู่..",
    },
    MISC: {
      HELLO: "สวัสดี",
      ASSOC_PROF: "ผู้ช่วยศาสตราจารย์",
    },
    TABLE: {
      NO_DATA_DISPLAY: "ไม่มีรายการแสดง",
      NO_DATA: "ไม่มีรายการ",
      TOTAL: "รวม",
      SUMMARY_TOTAL: "รวมทั้งหมด",
      TOTAL_RESULT: "ทั้งหมด",
      TOTAL_LIST: "รายการ",
      CUSTOMER_PATIENT: "ลูกค้า / ผู้ป่วย",
      AGE: "อายุ",
      AGE_YEAR: "อายุ (ปี)",
      ID: "เลขที่ประจำตัวบัตรประชาชน",
      PHONE: "เบอร์ติดต่อ",
      EMERGENCY: "ฉุกเฉิน",
      LINE: "LINE",
      LAST_UPDATED: "แก้ไขล่าสุด",
      LAST_LOGIN: "เข้าสู่ระบบล่าสุด",
      OPTION: "ตัวเลือก",
      BY: "by",
      CONNECTED: "เชื่อมต่อแล้ว",
      NOT_CONNECTED: "ไม่ได้เชื่อมต่อ",
      DOC_NO: "เลขที่",
      DATE: "วันที่",
      SUB_TOTAL: "ราคารวม",
      NET_PRICE: "ยอดรวม",
      PAID_PRICE: "ยอดที่ต้องชำระ",
      STATUS: "สถานะ",
      PAID: "ชำระแล้ว",
      REFERENCE: "อ้างอิงจาก",
      ISSUED_BY: "ออกให้โดย",
      ITEMS: "รายการ",
      PRICE_PER_UNIT: "ราคา/หน่วย",
      AMOUNT: "จำนวน",
      DISCOUNT: "ส่วนลด",
      BAHT: "บาท",
      MEDICINE_USAGE: "การใช้ยา",
      VAT: "ภาษีมูลค่าเพิ่ม ({{value}})",
      SERVICE_DATE: "วันที่รับบริการ",
      COMPLETED_DATE: "วันที่รับบริการเสร็จสิ้น",
      EXAMINATION_ROOM: "ห้องตรวจรักษา",

      // REPORT
      RECEIPT_NO: "เลขที่ใบเสร็จ",
      APPOINTMENT: "นัดหมาย",

      // SETTING
      CODE: "รหัส",
      PRICE: "ราคา",
      UNIT: "หน่วย",
      NUMBER_OF_MEDICINE: "จำนวนรายการยา",
      ACCOUNT_NAME: "ชื่อบัญชี",
      ACCOUNT_NO: "เลขที่บัญชี",
      USED_FOR: "ใช้สำหรับ",
      NAME: "ชื่อ",
      NAME_CODE: "ชื่อ / รหัส",
      LICENSE_NO: "เลขที่ใบอนุญาต",
      EMAIL: "อีเมล",
      ROLE: "บทบาท",
      DESCRIPTION: "คำอธิบาย",
      GROUP: "กลุ่ม",
      CATEGORY: "หมวดหมู่",
      TYPE: "ประเภท",
      UNIT_NAME: "ชื่อหน่วยนับ",
      PRIMARY_UNIT: "หน่วยหลัก",
      MULTIPILIER: "อัตรา/หน่วย",
      TIMES: "จำนวนครั้ง",
      SELL_PRICE: "ราคาขาย",
      TYPE_OF_SERVICE: "ลักษณะการให้บริการ",
      SHOW: "แสดง",
      ENTRIES: "รายการ",
      SEARCH: "ค้นหา",

      // REPORT
      OWNER_NAME: "ชื่อผู้ยื่น",
      Q_TIMES: "ครั้ง",
      Q_PEOPLE: "คน",

      PAGINATION_LIMIT_SHOWING:
        "แสดง {{start_value}} - {{end_value}}  จากทั้งหมด  {{total_value}} รายการ",
    },
    MANUAL: {
      BADGE: "คู่มือการใช้งาน",
      TITLE: "ใช้งานระบบได้ครบใน 10 นาที",
      SUBTITLE:
        "รวมทุกขั้นตอนพร้อมภาพหน้าจอจริง เลือกอ่านเป็นเรื่อง ๆ หรือดูวิดีโอสั้นของแต่ละหัวข้อก็ได้",
      MODE: "รูปแบบคู่มือ",
      MODE_READ: "แบบอ่าน",
      MODE_VIDEO: "แบบวิดีโอ",
      SEARCH: "ค้นหาในคู่มือ เช่น แบบฝึกหัด ตะกร้า รหัสผ่าน",
      EXPAND_ALL: "เปิดทุกหัวข้อ",
      COLLAPSE_ALL: "ย่อทุกหัวข้อ",
      CONTENTS: "สารบัญ",
      STEPS: "ขั้นตอน",
      STEP: "ขั้นที่",
      TRY_IT: "ไปลองใช้จริง",
      WATCH_INSTEAD: "ดูเป็นวิดีโอ",
      READ_INSTEAD: "อ่านแบบละเอียด",
      POINT: "จุดที่",
      OUTRO_TITLE: "ดูขั้นตอนแบบละเอียดได้ในคู่มือ",
      OUTRO_BODY: "เมนู คู่มือการใช้งาน · อ่านทีละขั้นพร้อมภาพหน้าจอทุกหน้า",
      IN_THIS_VIDEO: "ในวิดีโอนี้มีอะไรบ้าง",
      NO_RESULTS: "ไม่พบหัวข้อที่ค้นหา ลองใช้คำอื่น เช่น แบบฝึกหัด หรือ ผู้ปกครอง",
      M: {
        GETTING_STARTED: {
          TITLE: "เริ่มต้นใช้งาน",
          DESC: "เปิดเว็บครั้งแรก เข้าสู่ระบบ และสมัครสมาชิก",
          VIDEO: "ตั้งแต่เปิดเว็บครั้งแรกจนเข้าสู่ระบบสำเร็จ",
          S: {
            HOME: {
              TITLE: "หน้าแรกของระบบ",
              BODY: "หน้าแรกรวมทางเข้าทุกส่วนไว้ที่แถบเมนูด้านบน ยังไม่ต้องมีบัญชีก็เดินดูคอร์สและบทความได้",
              MARKS: {
                nav: "แถบเมนูหลัก ใช้ข้ามไปยังคอร์สเรียน บทความ และเกี่ยวกับเรา",
                cta: "ปุ่มลัดไปดูคอร์สทั้งหมด",
                login: "ปุ่มเข้าสู่ระบบ อยู่มุมขวาบนเสมอ",
              },
            },
            SIGN_IN: {
              TITLE: "เข้าสู่ระบบ",
              BODY: "ระบบไม่มีหน้าล็อกอินแยก แต่จะเปิดหน้าต่างขึ้นมาเมื่อคุณเข้าหน้าที่ต้องล็อกอิน กรอกอีเมลกับรหัสผ่านแล้วกดเข้าสู่ระบบ",
              MARKS: {
                email: "ช่องอีเมลและรหัสผ่านของบัญชีคุณ",
                demo: "ปุ่มทดลองใช้ทันที เข้าด้วยบัญชีตัวอย่างโดยไม่ต้องสมัคร มีเฉพาะในระบบสาธิต",
                forgot: "ลืมรหัสผ่าน ระบบจะส่งลิงก์ตั้งรหัสใหม่ไปทางอีเมล",
                register: "ยังไม่มีบัญชี กดลงทะเบียนได้จากตรงนี้",
              },
            },
            REGISTER: {
              TITLE: "สมัครสมาชิก",
              BODY: "กรอกข้อมูลพื้นฐานและเลือกประเภทผู้ใช้ นักเรียนใช้เรียนและทำแบบฝึกหัด ผู้ปกครองใช้ติดตามผลของบุตรหลาน",
              MARKS: {
                role: "เลือกสมัครเป็นนักเรียนหรือผู้ปกครอง",
                submit: "กดยืนยันเพื่อสร้างบัญชี",
              },
            },
            SIGNED_IN: {
              TITLE: "หลังเข้าสู่ระบบ",
              BODY: "เมื่อเข้าสู่ระบบแล้ว เมนูจะเพิ่มห้องเรียนออนไลน์ แบบฝึกหัด และทักษะของฉัน พร้อมไอคอนบัญชีที่มุมขวาบน",
              MARKS: {
                avatar: "ไอคอนบัญชี กดเพื่อไปโปรไฟล์ ประวัติคำสั่งซื้อ หรือออกจากระบบ",
                cart: "ตะกร้าสินค้า แสดงจำนวนคอร์สที่เลือกไว้",
                ribbon: "แถบระบบสาธิต บอกว่าข้อมูลทั้งหมดเป็นตัวอย่าง",
              },
            },
          },
        },
        COURSES: {
          TITLE: "ค้นหาคอร์สเรียน",
          DESC: "ดูคอร์สทั้งหมด อ่านรายละเอียด และทดลองเรียนฟรี",
          VIDEO: "วิธีหาคอร์สที่ต้องการและอ่านรายละเอียดก่อนตัดสินใจ",
          S: {
            LIST: {
              TITLE: "รายการคอร์สทั้งหมด",
              BODY: "คอร์สถูกจัดกลุ่มตามหมวดหมู่ แต่ละการ์ดบอกชื่อคอร์ส ผู้สอน และราคา กดที่การ์ดเพื่อดูรายละเอียด",
              MARKS: {
                card: "การ์ดคอร์ส กดเพื่อเปิดรายละเอียด",
                filter: "ตัวกรองหมวดหมู่ ใช้ดูเฉพาะกลุ่มที่สนใจ",
              },
            },
            DETAIL: {
              TITLE: "รายละเอียดคอร์ส",
              BODY: "หน้านี้บอกทุกอย่างก่อนตัดสินใจ ทั้งคำอธิบาย ผู้สอน จำนวนบทเรียน ระยะเวลาเรียน และสิ่งที่ได้รับ",
              MARKS: {
                title: "ชื่อคอร์สและคะแนนรีวิวจากผู้เรียน",
                enroll: "สมัครเรียน ข้ามตะกร้าไปขั้นตอนชำระเงินทันที",
                cart: "เพิ่มลงตะกร้า ถ้าอยากเลือกหลายคอร์สก่อนจ่ายทีเดียว",
                trial: "ทดลองเรียน ดูบทเรียนตัวอย่างฟรีโดยไม่ต้องซื้อ",
              },
            },
          },
        },
        PURCHASE: {
          TITLE: "สั่งซื้อและชำระเงิน",
          DESC: "ตะกร้าสินค้า การชำระเงิน และประวัติคำสั่งซื้อ",
          VIDEO: "ตั้งแต่ใส่ตะกร้าจนได้สิทธิ์เข้าเรียน",
          S: {
            CART: {
              TITLE: "ตะกร้าสินค้า",
              BODY: "ตะกร้าเปิดจากด้านขวาของจอ ตรวจรายการและใส่รหัสส่วนลดได้ก่อนกดชำระเงิน",
              MARKS: {
                items: "รายการคอร์สในตะกร้า ลบออกได้จากไอคอนถังขยะ",
                notice: "ในระบบสาธิต การสั่งซื้อเป็นการจำลอง ไม่มีการตัดเงินจริง",
                pay: "กดชำระเงินเพื่อไปขั้นตอนถัดไป",
              },
            },
            ORDERS: {
              TITLE: "ประวัติคำสั่งซื้อ",
              BODY: "คำสั่งซื้อทุกใบเก็บไว้ที่นี่ พร้อมสถานะว่ารอชำระ เสร็จสิ้น หรือยกเลิก",
              MARKS: {
                table: "ตารางคำสั่งซื้อ เรียงจากล่าสุด",
                row: "กดที่แถวเพื่อดูรายละเอียดของคำสั่งซื้อนั้น",
              },
            },
            ORDER_DETAIL: {
              TITLE: "รายละเอียดคำสั่งซื้อ",
              BODY: "หน้ารายละเอียดแสดงคอร์สในคำสั่งซื้อ ยอดรวม และสถานะการชำระเงิน",
              MARKS: {
                detail: "สรุปรายการและยอดที่ต้องชำระ",
                code: "รหัสคำสั่งซื้อ ใช้อ้างอิงเวลาติดต่อเจ้าหน้าที่",
              },
            },
          },
        },
        ONLINE_CLASS: {
          TITLE: "ห้องเรียนออนไลน์",
          DESC: "เข้าเรียน ดูวิดีโอบทเรียน และเอกสารประกอบ",
          VIDEO: "วิธีเข้าเรียนและใช้หน้าเล่นวิดีโอ",
          S: {
            DASHBOARD: {
              TITLE: "คอร์สของฉัน",
              BODY: "รวมคอร์สที่คุณมีสิทธิ์เรียน พร้อมความคืบหน้าของแต่ละคอร์ส",
              MARKS: {
                heading: "หัวข้อคอร์สของฉัน",
                card: "การ์ดคอร์สพร้อมความคืบหน้าและเวลาที่เหลือ",
                enter: "กดเข้าเรียนเพื่อเปิดห้องเรียน",
              },
            },
            START: {
              TITLE: "ก่อนเริ่มบทเรียน",
              BODY: "คอร์สมีเวลาเรียนจำกัด ระบบเริ่มนับเวลาเมื่อคุณเข้าห้องเรียน ถ้าต้องพักให้กดพักการเรียนชั่วคราวเพื่อหยุดนับเวลา",
              MARKS: {
                enter: "กดเข้าสู่คอร์สเรียนเพื่อเริ่ม",
                pause: "พักการเรียนชั่วคราว ใช้เมื่อยังไม่พร้อมเรียนต่อ",
              },
            },
            WATCH: {
              TITLE: "หน้าเรียนและวิดีโอ",
              BODY: "เลือกบทเรียนจากรายการด้านขวา ระบบจำตำแหน่งที่ดูค้างไว้ให้ และมีเอกสารประกอบอยู่ในแท็บด้านล่าง",
              MARKS: {
                player: "หน้าจอวิดีโอ ปรับความเร็วและเต็มจอได้จากแถบควบคุม",
                chapters: "รายการบทเรียนพร้อมความยาวของแต่ละบท",
                tabs: "แท็บเกี่ยวกับบทเรียนและไฟล์เอกสาร PDF",
              },
            },
            LESSON_QUIZZES: {
              TITLE: "แบบฝึกหัดท้ายบท",
              BODY: "ใต้บทเรียนจะมีแบบฝึกหัดของคอร์สนั้น กดเริ่มทำได้ทันทีหลังดูวิดีโอจบ",
              MARKS: {
                quizzes: "รายการแบบฝึกหัดที่ผูกกับบทเรียนนี้",
              },
            },
          },
        },
        QUIZ: {
          TITLE: "แบบฝึกหัด",
          DESC: "ทำแบบฝึกหัด ตรวจอัตโนมัติ และดูเฉลยพร้อมคำอธิบาย",
          VIDEO: "ทำแบบฝึกหัดหนึ่งชุดตั้งแต่ต้นจนเห็นผล",
          S: {
            LIST: {
              TITLE: "เลือกแบบฝึกหัด",
              BODY: "รวมแบบฝึกหัดของทุกคอร์สที่คุณเรียนอยู่ พร้อมจำนวนข้อ เกณฑ์ผ่าน และคะแนนที่ดีที่สุดของคุณ",
              MARKS: {
                list: "รายการแบบฝึกหัดทั้งหมด",
                start: "กดเริ่มทำเพื่อเข้าสู่ข้อแรก",
                best: "คะแนนที่ดีที่สุดที่เคยทำได้",
              },
            },
            DRILLS: {
              TITLE: "ชุดฝึกของฉัน",
              BODY: "ชุดฝึกสร้างจากหัวข้อที่คุณยังอ่อน ทำซ้ำได้เรื่อย ๆ และได้ข้อใหม่ทุกครั้ง",
              MARKS: {
                drills: "รายการชุดฝึกที่ระบบสร้างให้จากจุดอ่อนของคุณ",
              },
            },
            QUESTION: {
              TITLE: "ระหว่างทำแบบฝึกหัด",
              BODY: "ทำทีละข้อ เลือกคำตอบแล้วกดถัดไป ย้อนกลับไปแก้ข้อเดิมได้เสมอ แถบด้านบนบอกว่าอยู่ข้อที่เท่าไร",
              MARKS: {
                index: "ตำแหน่งข้อปัจจุบันและแถบความคืบหน้า",
                body: "โจทย์ พร้อมป้ายบอกหัวข้อของข้อนั้น",
                choice: "กดที่ตัวเลือกเพื่อตอบ",
                advance: "ถัดไป หรือย้อนกลับไปข้อก่อนหน้า",
              },
            },
            REVIEW: {
              TITLE: "ตรวจทานก่อนส่ง",
              BODY: "หน้าสรุปก่อนส่งจะบอกว่ายังมีข้อไหนไม่ได้ตอบ กดที่หมายเลขข้อเพื่อกลับไปแก้ได้",
              MARKS: {
                heading: "หน้าตรวจทานคำตอบ",
                unanswered: "แจ้งเตือนข้อที่ยังไม่ได้ตอบ",
                submit: "กดส่งคำตอบเมื่อพร้อม",
              },
            },
            RESULT: {
              TITLE: "ผลการทำแบบฝึกหัด",
              BODY: "ระบบตรวจให้อัตโนมัติทันทีที่ส่ง แสดงคะแนนรวมและผลแยกตามระดับความยาก",
              MARKS: {
                score: "คะแนนรวมเป็นเปอร์เซ็นต์ และผ่านเกณฑ์หรือไม่",
                difficulty: "ผลแยกตามระดับความยากของข้อ",
              },
            },
            BREAKDOWN: {
              TITLE: "ผลแยกตามหัวข้อ",
              BODY: "บอกว่าคุณทำได้ดีในหัวข้อไหนและพลาดหัวข้อไหน เป็นข้อมูลชุดเดียวกับที่ใช้สรุปทักษะของคุณ",
              MARKS: {
                skills: "สัดส่วนข้อที่ตอบถูกในแต่ละหัวข้อ",
                skillslink: "ลิงก์ไปหน้าทักษะของฉัน",
              },
            },
            ANSWER_KEY: {
              TITLE: "เฉลยและคำอธิบาย",
              BODY: "ทุกข้อมีเฉลยพร้อมคำอธิบายว่าทำไมคำตอบนั้นถูก และคำตอบของคุณพลาดตรงไหน",
              MARKS: {
                answers: "เฉลยรายข้อ เทียบคำตอบของคุณกับคำตอบที่ถูก",
                misconception: "คำอธิบายจุดที่มักเข้าใจผิด",
              },
            },
          },
        },
        SKILLS: {
          TITLE: "ทักษะของฉัน",
          DESC: "สรุปว่าคุณเก่งเรื่องไหน ควรทบทวนเรื่องไหน และควรทำอะไรต่อ",
          VIDEO: "อ่านผลวิเคราะห์ทักษะ และสร้างชุดฝึกจากจุดอ่อน",
          S: {
            OVERVIEW: {
              TITLE: "ภาพรวมทักษะ",
              BODY: "ระบบสรุปจากผลการทำแบบฝึกหัดย้อนหลัง โดยให้น้ำหนักผลล่าสุดมากกว่า หัวข้อที่เพิ่งแก้ไปแล้วจึงไม่ถูกผลเก่าดึงลง",
              MARKS: {
                heading: "หน้าทักษะของฉัน",
                narrative: "สรุปเป็นข้อความ อ่านรวดเดียวจบ",
                ability: "ตัวเลขรวม เช่น จำนวนข้อที่ทำแล้ว เรื่องที่แข็ง และเรื่องที่ต้องทบทวน",
              },
            },
            WEAK: {
              TITLE: "เรื่องที่ควรทบทวน",
              BODY: "หัวข้อที่ยังอ่อนจะเรียงไว้พร้อมสถิติล่าสุด กดฝึกเรื่องนี้แล้วระบบจะสร้างชุดฝึกเฉพาะหัวข้อนั้นให้ทันที",
              MARKS: {
                topic: "หัวข้อที่ควรทบทวน พร้อมปุ่มฝึกเรื่องนี้",
                misconceptions: "จุดที่มักเข้าใจผิดซ้ำ ๆ",
                stale: "ป้ายบอกว่าเรื่องนี้ไม่ได้ทบทวนมานานแล้ว",
              },
            },
            NEXT: {
              TITLE: "ควรทำอะไรต่อ",
              BODY: "คำแนะนำขั้นถัดไป ทั้งบทเรียนที่ควรกลับไปดูและคอร์สที่เหมาะกับจุดที่ยังขาด",
              MARKS: {
                recommendations: "รายการสิ่งที่ควรทำต่อ",
                suggestions: "คอร์สที่แนะนำจากผลทักษะ",
              },
            },
          },
        },
        PROFILE: {
          TITLE: "โปรไฟล์และรายงาน",
          DESC: "บันทึกการเรียน ประวัติแบบฝึกหัด ข้อมูลบัญชี และการเชื่อมผู้ปกครอง",
          VIDEO: "ดูรายงานการเรียนและตั้งค่าบัญชีของคุณ",
          S: {
            STUDY_RECORD: {
              TITLE: "บันทึกข้อมูลการเรียน",
              BODY: "สรุปเวลาเรียนและกิจกรรมของคุณ ใช้ดูว่าเรียนสม่ำเสมอแค่ไหน",
              MARKS: {
                heading: "หน้าบันทึกข้อมูลการเรียน",
                chart: "กราฟเวลาเรียนย้อนหลัง",
                activity: "รายการกิจกรรมล่าสุด",
                tabs: "สลับไปดูประวัติแบบฝึกหัดและทักษะ",
              },
            },
            QUIZ_RECORD: {
              TITLE: "ประวัติแบบฝึกหัด",
              BODY: "ทุกครั้งที่ทำแบบฝึกหัดจะถูกบันทึกไว้ กดที่รายการเพื่อเปิดผลและเฉลยของครั้งนั้น",
              MARKS: {
                record: "รายการครั้งที่ทำ พร้อมคะแนนและวันที่",
                tabskills: "แท็บทักษะ สรุปผลรวมของทุกครั้ง",
              },
            },
            ACCOUNT: {
              TITLE: "บัญชีและโปรไฟล์",
              BODY: "แก้ชื่อ อีเมล เบอร์โทร และรูปโปรไฟล์ แล้วกดบันทึก",
              MARKS: {
                save: "กดบันทึกเมื่อแก้ไขเสร็จ",
              },
            },
            PARENT: {
              TITLE: "เชื่อมบัญชีผู้ปกครอง",
              BODY: "นักเรียนส่งลิงก์คำเชิญให้ผู้ปกครอง เมื่อผู้ปกครองเปิดลิงก์แล้วจะเห็นผลการเรียนของนักเรียนคนนั้น",
              MARKS: {
                add: "ช่องลิงก์คำเชิญผู้ปกครองของบัญชีนี้",
                code: "ปุ่มคัดลอกลิงก์ ส่งต่อให้ผู้ปกครองทางแชตหรืออีเมล",
                unlink: "ยกเลิกการเชื่อมบัญชีผู้ปกครอง",
              },
            },
            PASSWORD: {
              TITLE: "เปลี่ยนรหัสผ่าน",
              BODY: "กรอกรหัสผ่านใหม่และยืนยันอีกครั้ง แล้วกดบันทึก",
              MARKS: {
                save: "กดบันทึกเพื่อเปลี่ยนรหัสผ่าน",
              },
            },
          },
        },
        BLOG: {
          TITLE: "บทความ",
          DESC: "อ่านบทความและเทคนิคการเรียนจากทีมผู้สอน",
          VIDEO: "หาบทความที่สนใจแล้วอ่านต่อ",
          S: {
            LIST: {
              TITLE: "รายการบทความ",
              BODY: "บทความล่าสุดอยู่ด้านบน กดที่หัวข้อเพื่ออ่านต่อ",
              MARKS: {
                search: "ค้นหาบทความจากคำค้น หรือเลือกดูตามหมวดหมู่",
                row: "รายการบทความอื่น ๆ",
              },
            },
            DETAIL: {
              TITLE: "อ่านบทความ",
              BODY: "หน้าบทความแสดงเนื้อหาเต็ม พร้อมบทความที่เกี่ยวข้องด้านข้าง",
              MARKS: {
                article: "เนื้อหาบทความ",
              },
            },
          },
        },
      },
    },
  },
};
